import React,{useEffect,useState} from 'react';
import {supabase} from '../lib/supabase';
import {localDate} from '../lib/progress';
import {accountKey} from '../lib/localAccount';
export default function CloudAccount({user,children}) {
 const [ready,setReady]=useState(false),[error,setError]=useState(''),[retry,setRetry]=useState(0);
 useEffect(()=>{
  let active=true;const key=accountKey(user);
  const sync=async()=>{
   try {
    const pending=localStorage.getItem(`${key}_profile_pending`);
    const local=localStorage.getItem(`${key}_profile`);
    const start=localStorage.getItem(`${key}_reto_start_date`)||new Date().toISOString();
    if(local){const result=await supabase.from('user_profiles').upsert({user_id:user.id,profile:JSON.parse(pending||local),start_date:start,updated_at:new Date().toISOString()},{onConflict:'user_id',ignoreDuplicates:!pending});if(result.error)throw result.error;}
    const {data,error}=await supabase.from('user_profiles').select('profile,start_date').eq('user_id',user.id).maybeSingle();if(error)throw error;
    if(data && Number(data.profile?.peso)>0){
     const initial=await supabase.from('progress_entries').upsert({user_id:user.id,id:'initial',measured_on:localDate(new Date(data.start_date)),weight:Number(data.profile.peso),source:'initial'},{onConflict:'user_id,id',ignoreDuplicates:true});if(initial.error)throw initial.error;
    }
    if(!active)return;
    if(data){
     if(local && !localStorage.getItem(`${key}_profile_before_cloud`))localStorage.setItem(`${key}_profile_before_cloud`,local);
     // Do not overwrite a profile edited while this request was in flight.
     if(localStorage.getItem(`${key}_profile_pending`)===pending){localStorage.setItem(`${key}_profile`,JSON.stringify({...data.profile,userId:user.id,email:user.email}));localStorage.setItem(`${key}_reto_start_date`,data.start_date);localStorage.removeItem(`${key}_profile_pending`);}
    }
    setError('');setReady(true);
   }catch{if(active)setError('No se pudo sincronizar tu perfil. Tus datos locales siguen conservados. Reintenta para abrir tu cuenta sin perder información.');}
  };
  let queue=Promise.resolve();const schedule=()=>{queue=queue.then(sync);};schedule();
  window.addEventListener('profile-saved',schedule);window.addEventListener('online',schedule);
  return()=>{active=false;window.removeEventListener('profile-saved',schedule);window.removeEventListener('online',schedule);};
 },[user.id,retry]);
 return <>{error&&<div role="status" className="p-4 bg-amber-950 text-white">{error}<button className="p-2 underline" onClick={()=>setRetry(n=>n+1)}>Reintentar</button></div>}{ready?children:<div className="min-h-screen bg-black text-white grid place-items-center">Recuperando tu perfil…</div>}</>;
}
